
// event
//------------------------------------------------------------
$(function(){

    // スポット詳細
    //------------------------------------------------------------
    if( $("body").is("#event.detail") ){

        // // social button
        // //------------------------------------------------------------
        // // var shareUrl = encodeURI(document.URL);
        // var shareUrl = encodeURI("http://www.biwako-visitors.jp/");
        // var shareTitle = encodeURI(document.title);
        // var snsBox = $(".title-set .sns");
        // // var domain = document.URL.split('/kyoto/')[0];
        // // var domain = "http://www.biwako-visitors.jp";
        // // var ogimage = "/design/img/ogp.png";

        // var twitterURL = "//twitter.com/intent/tweet?text=" + shareTitle + "&url=" + shareUrl;
        // var facebookURL = "//www.facebook.com/sharer.php?u=" + shareUrl;
        // var lineURL = "//line.me/R/msg/text/?" + "[" + shareTitle + "]" + "[" + shareUrl + "]";

        // $(".twitter a", snsBox).attr("href", twitterURL);
        // $(".facebook a", snsBox).attr("href", facebookURL);
        // $(".line a", snsBox).attr("href", lineURL);

        // $("a", snsBox).attr("target", "_blank");

        // tooltip
        $(".cmn-title-detail .icon-list li a").each(function(){
            var text = $(this).text();
            $(this).attr("data-powertip", text);
        });


        $(".cmn-title-detail .icon-list li a").powerTip({
            fadeInTime: 50,
            fadeOutTime: 50,
            offset: 5
        });

        // moreボタン
        //------------------------------------------------------------
        var moreTarget = $(".post-body");
        $(".texts p:eq(0)", moreTarget).each(function(){
            var len = $(this).text().length;
            //

            if( len > 300 ){
                $(this).addClass("js-over");
                $(this).wrapInner('<span></span>');
                $(this).after('<p class="bt-more"><a href="javascript:void(0);">続きを表示</a></p>');
            }
        });

        $(".post-body .bt-more a").live('tap', function(){
            var that = $(this).parents().filter(".post-body");
            $(this).remove();
            $(".js-over", that).removeClass("js-over");
        });

    }
});



// WEBPACK FOOTER //
// ./_src/js/cont/event.js